import React from 'react';
import { useAdmin } from '../../context/AdminContext';

const AdminHeader = ({ setSidebarOpen, title = 'Admin Dashboard' }) => {
  const { currentAdmin } = useAdmin();

  return (
    <header className="app-header">
      <div className="header-container">
        <div className="header-left">
          <button
            className="menu-button"
            onClick={() => setSidebarOpen(true)}
          >
            <span>☰</span>
          </button>
          <h1 className="header-title">{title}</h1>
        </div>
        <div className="header-right">
          <div className="header-user">
            <span className="user-greeting">Welcome, {currentAdmin?.name || 'Admin'}</span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default AdminHeader; 